
@if (vm.showHeader) {

<div class="flex justify-between py-2">

    <h2>
        Project Number: {{vm.project.projectNumber}}<br />{{vm.project.projectName}}
    </h2>

    <div class="project-header-logo hidden sm:block">
        <img [src]="vm.project.logoUrl?.value ?? ''" class="max-h-64 max-w-64" />
    </div>

</div>


}





